import React, { Component } from 'react'
import SerachIcon from "../../icons/searchicon";
import PostAcceptanceTable from "./../../component/PostAcceptanceTable";
import CreateProjectPopup from './createProjectPopup'
import service from "../../services";
import _ from 'lodash'

class PostAcceptanceList extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            addProjectPopup:false,
            pafSearch:'',
            isAbleConvertFPG:false
        }
        this.apiserve = new service();
        this.debounceSearch = _.debounce(this.debounceSearch,1500)
        this.ref = React.createRef()
    }

    updateFpgStatus = (status) => {
        this.setState({ isAbleConvertFPG: status });
    }

// DropDown Add Remove Function

    AddProject = () => {
        this.setState({
            addProjectPopup:true
        })
    }
    
    closeProject = () => {
        this.setState({
            addProjectPopup:false
        })
    }

    debounceSearch = () => {
        var data = {
            page: 1,
            limit: 50,
            
        }

        if(this.state.pafSearch.length) data.filter = this.state.pafSearch
        this.apiserve.sendevent("paf|project|searchProject",data)
    }

    onSearchChange=(e)=>{
        this.setState({
            [e.target.name]: e.target.value,
            currentPage:0
        });
        this.debounceSearch()
       
    }
    
    clearSearch =()=>{
        this.setState({
            pafSearch : '' 
        })
    }

    fpgConvert = () => {
        this.ref.current.AllFPGCONVERT()
    }

    render() {
        return (
            <>
            <div className="right_side_wrapper adminDashboard_wrapper postAcceptence_dashboard">
                <div className="dashboard_header with_btn">
                    <div className="searchBlock">
                        <span>Post-Acceptance Form Projects</span>
                        <form className="ml_10" onSubmit={(e)=>e.preventDefault()}>
                            <input type="text" placeholder="Search" name='pafSearch'  id="pafSearch" value={this.state.pafSearch} onChange={this.onSearchChange}/>
                            <button type="submit">
                                <SerachIcon />
                                {/* <img src={serachIcon} /> */}
                            </button>
                        </form>
                    </div>
                    <div className="button_block d_flex">
                        <span className={`${this.state.isAbleConvertFPG ? 'enable' : 'disable'}`} onClick={() => this.state.isAbleConvertFPG ? this.fpgConvert() : {}} title='Promote all submitted PAF projects'>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 0H1.99C0.88 0 0.00999999 0.9 0.00999999 2L0 16C0 17.1 0.88 18 1.99 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM16 12H12C12 13.66 10.65 15 9 15C7.35 15 6 13.66 6 12H1.99V2H16V12ZM13 7H11V4H7V7H5L9 11L13 7Z" fill="white" />
                            </svg>
                        </span>
                        <p className="head_btn pointer" onClick={() => this.AddProject()}>Add Project</p>
                    </div>
                </div>
                <div className="dashboard_data striped_table">
                    <PostAcceptanceTable history={this.props.history} ref={this.ref} search={this.state.pafSearch} clearSearch={this.clearSearch} updateFpgStatus={this.updateFpgStatus} />
                </div>


            </div>
            {/* Create Project Popup */}
                {
                    this.state.addProjectPopup && <CreateProjectPopup 
                        closeProject={this.closeProject}
                        filmId={this.state.filmId}
                        film={this.props.film}
                    /> 
                }
            </>
        )
    }
}
export default PostAcceptanceList